import { useState } from 'react';

function DatabaseManagementModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to DBMS",
      content: [
        "What is a Database Management System (DBMS)?",
        "Types of DBMS: Hierarchical, Network, Relational, and Object-Oriented",
        "Advantages of Using DBMS",
        "Components of DBMS: DBMS Engine, Database Schema, Query Processor, and More",
        "Database Models: Relational Model, Entity-Relationship Model",
        "Overview of SQL (Structured Query Language)"
      ]
    },
    {
      title: "Module 2: Database Design and ER Model",
      content: [
        "Entity-Relationship (ER) Model: Definition, Symbols, and Diagrams",
        "Entity Types, Attributes, and Relationships",
        "ER Diagrams: Mapping Entities and Relationships to Diagrams",
        "Normalization: Purpose, Types (1NF, 2NF, 3NF, BCNF)",
        "Functional Dependencies and Decomposition",
        "Designing an ER Model for Real-World Applications"
      ]
    },
    {
      title: "Module 3: Relational Database Management Systems (RDBMS)",
      content: [
        "What is RDBMS?",
        "Relational Data Model and its Components: Tables, Tuples, Attributes",
        "Primary Keys, Foreign Keys, and Referential Integrity",
        "Normalization in RDBMS: 1NF, 2NF, 3NF, and BCNF",
        "Relational Algebra: Basic Operations (Select, Project, Union, Intersection, Join)",
        "Relational Calculus and its Types",
        "SQL Syntax: SELECT, INSERT, UPDATE, DELETE"
      ]
    },
    {
      title: "Module 4: SQL Queries and Operators",
      content: [
        "Introduction to SQL",
        "SQL Data Types: INT, VARCHAR, DATE, etc.",
        "SQL Clauses: WHERE, GROUP BY, HAVING, ORDER BY",
        "SQL Joins: INNER JOIN, LEFT JOIN, RIGHT JOIN, FULL JOIN",
        "SQL Aggregate Functions: COUNT(), SUM(), AVG(), MAX(), MIN()",
        "Subqueries: Nested SELECT Statements",
        "Set Operations in SQL: UNION, INTERSECT, EXCEPT",
        "SQL Constraints: PRIMARY KEY, FOREIGN KEY, NOT NULL, UNIQUE"
      ]
    },
    {
      title: "Module 5: Indexing and Optimization",
      content: [
        "What is Indexing in DBMS?",
        "Types of Indexes: Single-Level Index, Multi-Level Index, Hash Index",
        "B+ Tree and Binary Tree Indexing",
        "Clustered vs Non-Clustered Index",
        "Indexing for Speed and Performance Optimization",
        "Query Optimization Techniques",
        "Cost-Based Query Optimization"
      ]
    },
    {
      title: "Module 6: Transactions and Concurrency Control",
      content: [
        "What is a Transaction in DBMS?",
        "ACID Properties of Transactions (Atomicity, Consistency, Isolation, Durability)",
        "Transaction Control Commands: COMMIT, ROLLBACK",
        "Concurrency Control: Issues and Techniques",
        "Locking Mechanisms: Shared Lock, Exclusive Lock",
        "Deadlock: Detection, Prevention, and Resolution",
        "Isolation Levels: Read Uncommitted, Read Committed, Repeatable Read, Serializable"
      ]
    },
    {
      title: "Module 7: Database Recovery and Backup",
      content: [
        "What is Database Recovery?",
        "Types of Recovery: Transaction Log-based Recovery, Checkpoint-based Recovery",
        "Database Backup Strategies: Full Backup, Incremental Backup, Differential Backup",
        "Point-in-Time Recovery",
        "Disaster Recovery Planning and Strategies"
      ]
    },
    {
      title: "Module 8: NoSQL Databases: MongoDB",
      content: [
        "Introduction to NoSQL Databases",
        "Why Use MongoDB (Document-Oriented NoSQL Database)?",
        "MongoDB Architecture: Documents, Collections, and Databases",
        "Basic MongoDB Commands: INSERT, FIND, UPDATE, DELETE",
        "Data Modeling in MongoDB: Embedding vs Referencing",
        "Indexes in MongoDB: Single Field Index, Compound Index",
        "Aggregation Framework in MongoDB",
        "Sharding and Replication in MongoDB",
        "MongoDB vs RDBMS: Key Differences"
      ]
    },
    {
      title: "Module 9: Database Security and Integrity",
      content: [
        "Database Security Principles and Threats",
        "Authentication and Authorization in DBMS",
        "Data Encryption: Transparent Data Encryption (TDE), Field-Level Encryption",
        "Integrity Constraints: Entity Integrity, Referential Integrity",
        "Backup and Recovery Security",
        "Audit Trails and Database Logs"
      ]
    },
    {
      title: "Module 10: Advanced Topics in DBMS",
      content: [
        "Distributed Databases and Architecture",
        "CAP Theorem (Consistency, Availability, Partition Tolerance)",
        "Data Warehousing and OLAP (Online Analytical Processing)",
        "Data Mining and its Relationship with DBMS",
        "Big Data and NoSQL in Modern Applications",
        "Cloud Databases and Database-as-a-Service (DBaaS)"
      ]
    },
    {
      title: "Module 11: Database Administration (DBA)",
      content: [
        "Role and Responsibilities of a Database Administrator",
        "Database Installation, Configuration, and Maintenance",
        "Monitoring and Performance Tuning",
        "User Management and Access Control",
        "Backup, Recovery, and Restoration Strategies",
        "DBA Tools and Utilities"
      ]
    },
    {
      title: "Module 12: Future Trends in DBMS",
      content: [
        "Evolution of DBMS: From Relational to NoSQL and NewSQL",
        "AI and Machine Learning Integration with Databases",
        "Blockchain Technology and its Impact on DBMS",
        "Serverless Databases and their Benefits",
        "Graph Databases for Complex Relationships",
        "Quantum Databases and their Future"
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Database Management System (DBMS) Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px' }}>{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DatabaseManagementModule;
